import usePreliminaryLifecarePlanRequest from '../../hooks/usePreliminaryLifecarePlanRequest';
import PreliminaryLifecarePlanRequestLayout from './PreliminaryLifecarePlanRequestLayout';

const PreliminaryLifecarePlanRequest = () => {
    const state = usePreliminaryLifecarePlanRequest();
    return <PreliminaryLifecarePlanRequestLayout state={state} />;
};

export default PreliminaryLifecarePlanRequest;
